<div class="lmo-fcpo-add-loader-to-network">
  <div class="mines-table" class="mines-table">
    <mat-form-field class="full-width" *ngIf="!(loading$$ | async)">
      <input matInput placeholder="Search" type="text" autocomplete="off" [formControl]="search" />
    </mat-form-field>
    <table mat-table [dataSource]="dataSource" matSort class="mine-picker">
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>name</th>
        <td mat-cell *matCellDef="let mine">{{ mine.name }}</td>
      </ng-container>

      <ng-container matColumnDef="distance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>distance</th>
        <td mat-cell *matCellDef="let mine">{{ mine.distance | number: '1.0-1' }} Miles</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="select(row)" class="selectable-row"></tr>
    </table>

    <div class="loading" *ngIf="loading$$ | async">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="mine-details">
    <ng-container *ngIf="selectedMine && !(selectedMineLoading$$ | async)">
      <h4>Loader Details</h4>
      <h3>{{ selectedMine.name }}</h3>
      <div class="info">Current In & Out Time: {{ selectedMine.waitTime | minutesToHuman }}</div>
      <div class="info">Distance To Well: {{ selectedMine.distance | number: '1.0-1' }} Miles</div>
      <div class="info">Updated: {{ selectedMine.updatedTimestamp | ago }}</div>
      <div class="action-row">
        <button mat-stroked-button color="primary" (click)="addToNetwork()">Add To Contracted</button>
      </div>
    </ng-container>
    <div class="loading" *ngIf="selectedMineLoading$$ | async">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>
